export const Twitter = () => {
  return (
    <div>
      <svg
        className="icon-hover"
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.50498 29.2291C6.50498 16.6789 16.6789 6.50498 29.2291 6.50498C41.7793 6.50498 51.9532 16.6789 51.9532 29.2291C51.9532 41.7793 41.7793 51.9532 29.2291 51.9532C16.6789 51.9532 6.50498 41.7793 6.50498 29.2291Z"
          stroke="white"
          strokeWidth="1.00996"
        />
        <path
          d="M6.50498 29.2291C6.50498 16.6789 16.6789 6.50498 29.2291 6.50498C41.7793 6.50498 51.9532 16.6789 51.9532 29.2291C51.9532 41.7793 41.7793 51.9532 29.2291 51.9532C16.6789 51.9532 6.50498 41.7793 6.50498 29.2291Z"
          stroke="url(#paint0_linear_70_630)"
          strokeWidth="1.00996"
        />
        <g filter="url(#filter0_f_70_630)">
          <path
            d="M6.50498 29.2291C6.50498 16.6789 16.6789 6.50498 29.2291 6.50498C41.7793 6.50498 51.9532 16.6789 51.9532 29.2291C51.9532 41.7793 41.7793 51.9532 29.2291 51.9532C16.6789 51.9532 6.50498 41.7793 6.50498 29.2291Z"
            stroke="white"
            strokeWidth="1.00996"
          />
          <path
            d="M6.50498 29.2291C6.50498 16.6789 16.6789 6.50498 29.2291 6.50498C41.7793 6.50498 51.9532 16.6789 51.9532 29.2291C51.9532 41.7793 41.7793 51.9532 29.2291 51.9532C16.6789 51.9532 6.50498 41.7793 6.50498 29.2291Z"
            stroke="url(#paint1_linear_70_630)"
            strokeWidth="1.00996"
          />
        </g>
        <g clipPath="url(#clip0_70_630)">
          <path
            d="M41.0132 21.9867C40.1651 22.3604 39.2541 22.6129 38.2963 22.727C39.2845 22.139 40.0239 21.2136 40.3764 20.1233C39.4479 20.6717 38.4318 21.0578 37.3721 21.2646C36.6595 20.508 35.7157 20.0065 34.6871 19.838C33.6585 19.6695 32.6028 19.8434 31.6838 20.3327C30.7648 20.8219 30.0339 21.5993 29.6047 22.5439C29.1755 23.4886 29.0719 24.5477 29.31 25.5569C27.4287 25.463 25.5883 24.9768 23.9083 24.1298C22.2282 23.2828 20.746 22.0939 19.5579 20.6404C19.1516 21.3373 18.918 22.1453 18.918 23.0058C18.9176 23.7804 19.1094 24.5432 19.4765 25.2264C19.8436 25.9096 20.3746 26.4922 21.0224 26.9224C20.2711 26.8986 19.5364 26.6968 18.8794 26.3336V26.3942C18.8793 27.4806 19.2573 28.5337 19.9491 29.3746C20.6409 30.2155 21.6039 30.7925 22.6749 31.0077C21.9779 31.1953 21.2472 31.2229 20.538 31.0885C20.8401 32.0233 21.4287 32.8408 22.2212 33.4265C23.0138 34.0121 23.9707 34.3367 24.958 34.3547C23.282 35.663 21.2122 36.3727 19.0815 36.3696C18.7041 36.3697 18.327 36.3478 17.9521 36.3039C20.1149 37.6867 22.6325 38.4206 25.2038 38.4178C33.9078 38.4178 38.666 31.2491 38.666 25.0318C38.666 24.8298 38.6609 24.6257 38.6518 24.4238C39.5773 23.7582 40.3763 22.934 41.0111 21.9897L41.0132 21.9867Z"
            fill="white"
          />
          <path
            d="M41.0132 21.9867C40.1651 22.3604 39.2541 22.6129 38.2963 22.727C39.2845 22.139 40.0239 21.2136 40.3764 20.1233C39.4479 20.6717 38.4318 21.0578 37.3721 21.2646C36.6595 20.508 35.7157 20.0065 34.6871 19.838C33.6585 19.6695 32.6028 19.8434 31.6838 20.3327C30.7648 20.8219 30.0339 21.5993 29.6047 22.5439C29.1755 23.4886 29.0719 24.5477 29.31 25.5569C27.4287 25.463 25.5883 24.9768 23.9083 24.1298C22.2282 23.2828 20.746 22.0939 19.5579 20.6404C19.1516 21.3373 18.918 22.1453 18.918 23.0058C18.9176 23.7804 19.1094 24.5432 19.4765 25.2264C19.8436 25.9096 20.3746 26.4922 21.0224 26.9224C20.2711 26.8986 19.5364 26.6968 18.8794 26.3336V26.3942C18.8793 27.4806 19.2573 28.5337 19.9491 29.3746C20.6409 30.2155 21.6039 30.7925 22.6749 31.0077C21.9779 31.1953 21.2472 31.2229 20.538 31.0885C20.8401 32.0233 21.4287 32.8408 22.2212 33.4265C23.0138 34.0121 23.9707 34.3367 24.958 34.3547C23.282 35.663 21.2122 36.3727 19.0815 36.3696C18.7041 36.3697 18.327 36.3478 17.9521 36.3039C20.1149 37.6867 22.6325 38.4206 25.2038 38.4178C33.9078 38.4178 38.666 31.2491 38.666 25.0318C38.666 24.8298 38.6609 24.6257 38.6518 24.4238C39.5773 23.7582 40.3763 22.934 41.0111 21.9897L41.0132 21.9867Z"
            fill="url(#paint2_linear_70_630)"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_70_630"
            x="0.58328"
            y="0.58328"
            width="57.2914"
            height="57.2914"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.70836"
              result="effect1_foregroundBlur_70_630"
            />
          </filter>
          <linearGradient
            id="paint0_linear_70_630"
            x1="29.2291"
            y1="6"
            x2="29.2291"
            y2="52.4582"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_70_630"
            x1="29.2291"
            y1="6"
            x2="29.2291"
            y2="52.4582"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_70_630"
            x1="29.4827"
            y1="19.7754"
            x2="29.4827"
            y2="38.4178"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <clipPath id="clip0_70_630">
            <rect
              width="24.3752"
              height="24.2391"
              fill="white"
              transform="translate(17 17)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export const Discord = () => {
  return (
    <div>
      <svg
        className="icon-hover"
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.50498"
          y="6.50498"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="white"
          strokeWidth="1.00996"
        />
        <rect
          x="6.50498"
          y="6.50498"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="url(#paint0_linear_70_638)"
          strokeWidth="1.00996"
        />
        <g filter="url(#filter0_f_70_638)">
          <rect
            x="6.50498"
            y="6.50498"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="white"
            strokeWidth="1.00996"
          />
          <rect
            x="6.50498"
            y="6.50498"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="url(#paint1_linear_70_638)"
            strokeWidth="1.00996"
          />
        </g>
        <g clipPath="url(#clip0_70_638)">
          <path
            d="M37.6351 21.5381C36.0812 20.8412 34.4156 20.3261 32.6738 20.0333C32.6583 20.0303 32.6422 20.0322 32.6278 20.0387C32.6134 20.0452 32.6015 20.056 32.5935 20.0696C32.3802 20.4423 32.1426 20.9281 31.976 21.3119C30.1287 21.0374 28.2506 21.0374 26.4032 21.3119C26.2177 20.8865 26.0085 20.4718 25.7766 20.0696C25.7687 20.0559 25.7568 20.0448 25.7425 20.038C25.7282 20.0311 25.7121 20.0288 25.6964 20.0312C23.9556 20.3241 22.2899 20.8392 20.735 21.5371C20.7216 21.5427 20.7103 21.5522 20.7025 21.5644C17.5418 26.1849 16.6755 30.6914 17.101 35.1413C17.1022 35.1522 17.1056 35.1627 17.111 35.1723C17.1164 35.1818 17.1238 35.1902 17.1325 35.1968C18.9773 36.5324 21.0349 37.5498 23.2192 38.2065C23.2344 38.2112 23.2507 38.2111 23.266 38.2065C23.2812 38.2018 23.2946 38.1926 23.3045 38.1802C23.7738 37.5541 24.1922 36.8925 24.5497 36.1977C24.571 36.1573 24.5507 36.1088 24.5081 36.0926C23.852 35.8469 23.2163 35.5505 22.6068 35.2059C22.5958 35.1997 22.5866 35.1909 22.5799 35.1802C22.5733 35.1696 22.5693 35.1575 22.5685 35.145C22.5677 35.1324 22.5701 35.1199 22.5753 35.1085C22.5806 35.0971 22.5886 35.0872 22.5987 35.0797C22.7266 34.9857 22.8546 34.8878 22.9765 34.7898C22.9875 34.781 23.0007 34.7754 23.0147 34.7736C23.0286 34.7718 23.0429 34.7739 23.0557 34.7797C27.0441 36.5613 31.3636 36.5613 35.3053 34.7797C35.3182 34.7736 35.3325 34.7712 35.3467 34.7728C35.3609 34.7744 35.3743 34.7799 35.3855 34.7888C35.5074 34.8878 35.6343 34.9857 35.7633 35.0797C35.7735 35.087 35.7816 35.0968 35.7871 35.1081C35.7925 35.1194 35.795 35.1319 35.7944 35.1444C35.7938 35.1569 35.7901 35.1691 35.7836 35.1798C35.7771 35.1905 35.7681 35.1995 35.7572 35.2059C35.1499 35.5533 34.5182 35.8472 33.8549 36.0916C33.8448 36.0953 33.8355 36.1011 33.8277 36.1086C33.82 36.1162 33.8139 36.1252 33.81 36.1353C33.806 36.1453 33.8043 36.1561 33.8049 36.1668C33.8055 36.1776 33.8083 36.1881 33.8133 36.1977C34.1789 36.8915 34.5974 37.552 35.0575 38.1792C35.067 38.1921 35.0804 38.2017 35.0956 38.2068C35.1109 38.2118 35.1274 38.2121 35.1428 38.2075C37.3308 37.5527 39.3918 36.5348 41.2386 35.1968C41.2476 35.1905 41.2552 35.1824 41.2608 35.173C41.2664 35.1636 41.2699 35.1531 41.2711 35.1423C41.7789 29.9975 40.42 25.5274 37.6666 21.5664C37.6599 21.5535 37.6487 21.5435 37.6351 21.5381ZM25.1459 32.4315C23.9454 32.4315 22.9552 31.3519 22.9552 30.0278C22.9552 28.7028 23.9261 27.6241 25.1459 27.6241C26.3748 27.6241 27.3559 28.7118 27.3366 30.0278C27.3366 31.3529 26.3657 32.4315 25.1459 32.4315ZM33.2456 32.4315C32.0441 32.4315 31.0548 31.3519 31.0548 30.0278C31.0548 28.7028 32.0248 27.6241 33.2456 27.6241C34.4745 27.6241 35.4556 28.7118 35.4363 30.0278C35.4363 31.3529 34.4755 32.4315 33.2456 32.4315Z"
            fill="white"
          />
          <path
            d="M37.6351 21.5381C36.0812 20.8412 34.4156 20.3261 32.6738 20.0333C32.6583 20.0303 32.6422 20.0322 32.6278 20.0387C32.6134 20.0452 32.6015 20.056 32.5935 20.0696C32.3802 20.4423 32.1426 20.9281 31.976 21.3119C30.1287 21.0374 28.2506 21.0374 26.4032 21.3119C26.2177 20.8865 26.0085 20.4718 25.7766 20.0696C25.7687 20.0559 25.7568 20.0448 25.7425 20.038C25.7282 20.0311 25.7121 20.0288 25.6964 20.0312C23.9556 20.3241 22.2899 20.8392 20.735 21.5371C20.7216 21.5427 20.7103 21.5522 20.7025 21.5644C17.5418 26.1849 16.6755 30.6914 17.101 35.1413C17.1022 35.1522 17.1056 35.1627 17.111 35.1723C17.1164 35.1818 17.1238 35.1902 17.1325 35.1968C18.9773 36.5324 21.0349 37.5498 23.2192 38.2065C23.2344 38.2112 23.2507 38.2111 23.266 38.2065C23.2812 38.2018 23.2946 38.1926 23.3045 38.1802C23.7738 37.5541 24.1922 36.8925 24.5497 36.1977C24.571 36.1573 24.5507 36.1088 24.5081 36.0926C23.852 35.8469 23.2163 35.5505 22.6068 35.2059C22.5958 35.1997 22.5866 35.1909 22.5799 35.1802C22.5733 35.1696 22.5693 35.1575 22.5685 35.145C22.5677 35.1324 22.5701 35.1199 22.5753 35.1085C22.5806 35.0971 22.5886 35.0872 22.5987 35.0797C22.7266 34.9857 22.8546 34.8878 22.9765 34.7898C22.9875 34.781 23.0007 34.7754 23.0147 34.7736C23.0286 34.7718 23.0429 34.7739 23.0557 34.7797C27.0441 36.5613 31.3636 36.5613 35.3053 34.7797C35.3182 34.7736 35.3325 34.7712 35.3467 34.7728C35.3609 34.7744 35.3743 34.7799 35.3855 34.7888C35.5074 34.8878 35.6343 34.9857 35.7633 35.0797C35.7735 35.087 35.7816 35.0968 35.7871 35.1081C35.7925 35.1194 35.795 35.1319 35.7944 35.1444C35.7938 35.1569 35.7901 35.1691 35.7836 35.1798C35.7771 35.1905 35.7681 35.1995 35.7572 35.2059C35.1499 35.5533 34.5182 35.8472 33.8549 36.0916C33.8448 36.0953 33.8355 36.1011 33.8277 36.1086C33.82 36.1162 33.8139 36.1252 33.81 36.1353C33.806 36.1453 33.8043 36.1561 33.8049 36.1668C33.8055 36.1776 33.8083 36.1881 33.8133 36.1977C34.1789 36.8915 34.5974 37.552 35.0575 38.1792C35.067 38.1921 35.0804 38.2017 35.0956 38.2068C35.1109 38.2118 35.1274 38.2121 35.1428 38.2075C37.3308 37.5527 39.3918 36.5348 41.2386 35.1968C41.2476 35.1905 41.2552 35.1824 41.2608 35.173C41.2664 35.1636 41.2699 35.1531 41.2711 35.1423C41.7789 29.9975 40.42 25.5274 37.6666 21.5664C37.6599 21.5535 37.6487 21.5435 37.6351 21.5381ZM25.1459 32.4315C23.9454 32.4315 22.9552 31.3519 22.9552 30.0278C22.9552 28.7028 23.9261 27.6241 25.1459 27.6241C26.3748 27.6241 27.3559 28.7118 27.3366 30.0278C27.3366 31.3529 26.3657 32.4315 25.1459 32.4315ZM33.2456 32.4315C32.0441 32.4315 31.0548 31.3519 31.0548 30.0278C31.0548 28.7028 32.0248 27.6241 33.2456 27.6241C34.4745 27.6241 35.4556 28.7118 35.4363 30.0278C35.4363 31.3529 34.4755 32.4315 33.2456 32.4315Z"
            fill="url(#paint2_linear_70_638)"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_70_638"
            x="0.58328"
            y="0.58328"
            width="57.2914"
            height="57.2914"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.70836"
              result="effect1_foregroundBlur_70_638"
            />
          </filter>
          <linearGradient
            id="paint0_linear_70_638"
            x1="29.2291"
            y1="6"
            x2="29.2291"
            y2="52.4582"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_70_638"
            x1="29.2291"
            y1="6"
            x2="29.2291"
            y2="52.4582"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_70_638"
            x1="29.188"
            y1="20.0303"
            x2="29.188"
            y2="38.2108"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <clipPath id="clip0_70_638">
            <rect
              width="24.3752"
              height="24.2391"
              fill="white"
              transform="translate(17 17)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export const Telegram = () => {
  return (
    <div>
      <svg
        className="icon-hover"
        width="58"
        height="59"
        viewBox="0 0 58 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.25791"
          y="6.91123"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="white"
          strokeWidth="1.00996"
        />
        <rect
          x="6.25791"
          y="6.91123"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="url(#paint0_linear_110_93)"
          strokeWidth="1.00996"
        />
        <g filter="url(#filter0_f_110_93)">
          <rect
            x="6.25791"
            y="6.91123"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="white"
            strokeWidth="1.00996"
          />
          <rect
            x="6.25791"
            y="6.91123"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="url(#paint1_linear_110_93)"
            strokeWidth="1.00996"
          />
        </g>
        <path
          d="M38.4901 22.1837L35.2712 37.2769C35.0282 38.3419 34.3951 38.607 33.4953 38.1056L28.5903 34.512L26.224 36.7754C25.9619 37.036 25.7432 37.2534 25.2381 37.2534L25.5908 32.2872L34.6808 24.1206C35.0762 23.7707 34.5947 23.576 34.0667 23.9267L22.829 30.9624L17.9911 29.4564C16.939 29.13 16.9199 28.4103 18.2106 27.9081L37.1332 20.6596C38.0094 20.3331 38.7759 20.8535 38.4901 22.1844V22.1837Z"
          fill="url(#paint2_linear_110_93)"
        />
        <defs>
          <filter
            id="filter0_f_110_93"
            x="0.336209"
            y="0.98953"
            width="57.2914"
            height="57.2914"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.70836"
              result="effect1_foregroundBlur_110_93"
            />
          </filter>
          <linearGradient
            id="paint0_linear_110_93"
            x1="28.982"
            y1="6.40625"
            x2="28.982"
            y2="52.8645"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_110_93"
            x1="28.982"
            y1="6.40625"
            x2="28.982"
            y2="52.8645"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_110_93"
            x1="27.8858"
            y1="20.5649"
            x2="27.8858"
            y2="38.3504"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
export const InstaGram = () => {
  return (
    <div>
      <svg
        className="icon-hover"
        width="58"
        height="59"
        viewBox="0 0 58 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.23936"
          y="6.91123"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="white"
          strokeWidth="1.00996"
        />
        <rect
          x="6.23936"
          y="6.91123"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="url(#paint0_linear_111_11)"
          strokeWidth="1.00996"
        />
        <g filter="url(#filter0_f_111_11)">
          <rect
            x="6.23936"
            y="6.91123"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="white"
            strokeWidth="1.00996"
          />
          <rect
            x="6.23936"
            y="6.91123"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="url(#paint1_linear_111_11)"
            strokeWidth="1.00996"
          />
        </g>
        <path
          d="M28.9638 26.4797C27.2163 26.4797 25.7902 27.8977 25.7902 29.6352C25.7902 31.3727 27.2163 32.7907 28.9638 32.7907C30.7114 32.7907 32.1375 31.3727 32.1375 29.6352C32.1375 27.8977 30.7114 26.4797 28.9638 26.4797ZM38.4825 29.6352C38.4825 28.3285 38.4944 27.0337 38.4206 25.7293C38.3468 24.2143 37.9992 22.8698 36.885 21.7619C35.7683 20.6517 34.4184 20.3085 32.8946 20.2351C31.5804 20.1617 30.2781 20.1736 28.9662 20.1736C27.652 20.1736 26.3497 20.1617 25.0378 20.2351C23.5141 20.3085 22.1617 20.6541 21.0475 21.7619C19.9309 22.8721 19.5856 24.2143 19.5118 25.7293C19.438 27.036 19.4499 28.3309 19.4499 29.6352C19.4499 30.9395 19.438 32.2367 19.5118 33.5411C19.5856 35.0561 19.9332 36.4006 21.0475 37.5085C22.1641 38.6187 23.5141 38.9619 25.0378 39.0353C26.352 39.1087 27.6544 39.0969 28.9662 39.0969C30.2805 39.0969 31.5828 39.1087 32.8946 39.0353C34.4184 38.9619 35.7707 38.6163 36.885 37.5085C38.0016 36.3983 38.3468 35.0561 38.4206 33.5411C38.4968 32.2367 38.4825 30.9419 38.4825 29.6352V29.6352ZM28.9638 34.4903C26.2616 34.4903 24.0807 32.322 24.0807 29.6352C24.0807 26.9484 26.2616 24.7801 28.9638 24.7801C31.6661 24.7801 33.847 26.9484 33.847 29.6352C33.847 32.322 31.6661 34.4903 28.9638 34.4903ZM34.047 25.7151C33.416 25.7151 32.9065 25.2086 32.9065 24.5813C32.9065 23.954 33.416 23.4474 34.047 23.4474C34.6779 23.4474 35.1874 23.954 35.1874 24.5813C35.1876 24.7302 35.1582 24.8777 35.101 25.0154C35.0437 25.1531 34.9597 25.2781 34.8538 25.3835C34.7479 25.4888 34.6221 25.5723 34.4836 25.6292C34.3452 25.6861 34.1968 25.7153 34.047 25.7151V25.7151Z"
          fill="black"
        />
        <path
          d="M28.9638 26.4797C27.2163 26.4797 25.7902 27.8977 25.7902 29.6352C25.7902 31.3727 27.2163 32.7907 28.9638 32.7907C30.7114 32.7907 32.1375 31.3727 32.1375 29.6352C32.1375 27.8977 30.7114 26.4797 28.9638 26.4797ZM38.4825 29.6352C38.4825 28.3285 38.4944 27.0337 38.4206 25.7293C38.3468 24.2143 37.9992 22.8698 36.885 21.7619C35.7683 20.6517 34.4184 20.3085 32.8946 20.2351C31.5804 20.1617 30.2781 20.1736 28.9662 20.1736C27.652 20.1736 26.3497 20.1617 25.0378 20.2351C23.5141 20.3085 22.1617 20.6541 21.0475 21.7619C19.9309 22.8721 19.5856 24.2143 19.5118 25.7293C19.438 27.036 19.4499 28.3309 19.4499 29.6352C19.4499 30.9395 19.438 32.2367 19.5118 33.5411C19.5856 35.0561 19.9332 36.4006 21.0475 37.5085C22.1641 38.6187 23.5141 38.9619 25.0378 39.0353C26.352 39.1087 27.6544 39.0969 28.9662 39.0969C30.2805 39.0969 31.5828 39.1087 32.8946 39.0353C34.4184 38.9619 35.7707 38.6163 36.885 37.5085C38.0016 36.3983 38.3468 35.0561 38.4206 33.5411C38.4968 32.2367 38.4825 30.9419 38.4825 29.6352V29.6352ZM28.9638 34.4903C26.2616 34.4903 24.0807 32.322 24.0807 29.6352C24.0807 26.9484 26.2616 24.7801 28.9638 24.7801C31.6661 24.7801 33.847 26.9484 33.847 29.6352C33.847 32.322 31.6661 34.4903 28.9638 34.4903ZM34.047 25.7151C33.416 25.7151 32.9065 25.2086 32.9065 24.5813C32.9065 23.954 33.416 23.4474 34.047 23.4474C34.6779 23.4474 35.1874 23.954 35.1874 24.5813C35.1876 24.7302 35.1582 24.8777 35.101 25.0154C35.0437 25.1531 34.9597 25.2781 34.8538 25.3835C34.7479 25.4888 34.6221 25.5723 34.4836 25.6292C34.3452 25.6861 34.1968 25.7153 34.047 25.7151V25.7151Z"
          fill="url(#paint2_linear_111_11)"
        />
        <defs>
          <filter
            id="filter0_f_111_11"
            x="0.317655"
            y="0.98953"
            width="57.2914"
            height="57.2914"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.70836"
              result="effect1_foregroundBlur_111_11"
            />
          </filter>
          <linearGradient
            id="paint0_linear_111_11"
            x1="28.9635"
            y1="6.40625"
            x2="28.9635"
            y2="52.8645"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_111_11"
            x1="28.9635"
            y1="6.40625"
            x2="28.9635"
            y2="52.8645"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_111_11"
            x1="28.9664"
            y1="20.1729"
            x2="28.9664"
            y2="39.0976"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
export const Medium = () => {
  return (
    <div>
      <svg
        className="icon-hover"
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.3917"
          y="6.21152"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="white"
          strokeWidth="1.00996"
        />
        <rect
          x="6.3917"
          y="6.21152"
          width="45.4482"
          height="45.4482"
          rx="22.7241"
          stroke="url(#paint0_linear_110_79)"
          strokeWidth="1.00996"
        />
        <g filter="url(#filter0_f_110_79)">
          <rect
            x="6.3917"
            y="6.21152"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="white"
            strokeWidth="1.00996"
          />
          <rect
            x="6.3917"
            y="6.21152"
            width="45.4482"
            height="45.4482"
            rx="22.7241"
            stroke="url(#paint1_linear_110_79)"
            strokeWidth="1.00996"
          />
        </g>
        <path
          d="M37.0462 23.1386L38.5057 21.7443V21.439H33.4511L29.8489 30.3964L25.7514 21.439H20.4516V21.7443L22.1563 23.7943C22.323 23.9458 22.4087 24.1683 22.3873 24.3908V32.4464C22.4397 32.7376 22.3468 33.0335 22.1421 33.2441L20.2207 35.5711V35.8717H25.6633V35.5663L23.7444 33.2465C23.6416 33.1427 23.5642 33.0167 23.5184 32.8784C23.4725 32.74 23.4594 32.593 23.4801 32.4488V25.4798L28.2585 35.8764H28.8132L32.9226 25.4798V33.7625C32.9226 33.9803 32.9226 34.0253 32.7797 34.1697L31.3012 35.5971V35.9025H38.4724V35.5971L37.0462 34.2028C36.9224 34.1082 36.8581 33.9496 36.8843 33.7957V23.5458C36.872 23.4697 36.8805 23.3917 36.909 23.3201C36.9375 23.2484 36.9849 23.1857 37.0462 23.1386V23.1386Z"
          fill="black"
        />
        <path
          d="M37.0462 23.1386L38.5057 21.7443V21.439H33.4511L29.8489 30.3964L25.7514 21.439H20.4516V21.7443L22.1563 23.7943C22.323 23.9458 22.4087 24.1683 22.3873 24.3908V32.4464C22.4397 32.7376 22.3468 33.0335 22.1421 33.2441L20.2207 35.5711V35.8717H25.6633V35.5663L23.7444 33.2465C23.6416 33.1427 23.5642 33.0167 23.5184 32.8784C23.4725 32.74 23.4594 32.593 23.4801 32.4488V25.4798L28.2585 35.8764H28.8132L32.9226 25.4798V33.7625C32.9226 33.9803 32.9226 34.0253 32.7797 34.1697L31.3012 35.5971V35.9025H38.4724V35.5971L37.0462 34.2028C36.9224 34.1082 36.8581 33.9496 36.8843 33.7957V23.5458C36.872 23.4697 36.8805 23.3917 36.909 23.3201C36.9375 23.2484 36.9849 23.1857 37.0462 23.1386V23.1386Z"
          fill="url(#paint2_linear_110_79)"
        />
        <defs>
          <filter
            id="filter0_f_110_79"
            x="0.469998"
            y="0.289823"
            width="57.2914"
            height="57.2914"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.70836"
              result="effect1_foregroundBlur_110_79"
            />
          </filter>
          <linearGradient
            id="paint0_linear_110_79"
            x1="29.1158"
            y1="5.70654"
            x2="29.1158"
            y2="52.1648"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_110_79"
            x1="29.1158"
            y1="5.70654"
            x2="29.1158"
            y2="52.1648"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_110_79"
            x1="29.3632"
            y1="21.439"
            x2="29.3632"
            y2="35.9025"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FED710" />
            <stop offset="1" stopColor="#FF5001" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
// BACK TO TOP ICON
export const BackToTopIcon = () => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 8L7 3L2 8L0 7L7 0L14 7L12 8Z" fill="black" />
    </svg>
  );
};
